module.exports = __webpack_public_path__ + "static/media/civil7.af5cadf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/civil7.jpg
// module id = 5781
// module chunks = 0